import { useEffect } from "react";

/**
 * Hook that detects clicks outside of the passed ref
 */
function useOutsideClick(ref, callback) {
  useEffect(() => {
    /**
     * Callback if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

export default useOutsideClick;
